import { createGate } from "effector-react";

export const AdminGate = createGate();
